exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.nil-sa-elements-squareimage-style__imageContainer{position:relative;overflow:hidden;width:100%;border-radius:3px;background-position:50%;background-repeat:no-repeat;background-size:cover}div.nil-sa-elements-squareimage-style__imageContainer i{position:absolute;top:0}div.nil-sa-elements-squareimage-style__imageContainer:before{content:\"\";display:inline-block!important;padding-top:100%}", ""]);

// exports
exports.locals = {
	"imageContainer": "nil-sa-elements-squareimage-style__imageContainer"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/SquareImage/style.less
// module id = 386
// module chunks = 0